export const MASK = '11-11-1111';
export const PLACEHOLDER = 'dd/mm/aaaa';
export const FORMAT = 'dd-MM-yyyy';
export const LOCALE = 'es';
